import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import IndependentScorekeeper from '../../components/IndependentScorekeeper';

const ScoreToolPage = () => (
  <View style={styles.container}>
    <View style={styles.headerContainer}>
      <Text style={styles.title}>🎯 Segnapunti</Text>
      <View style={styles.divider} />
      <Text style={styles.subtitle}>Strumento per tenere traccia dei punteggi durante gli incontri</Text>
    </View>
    
    <View style={styles.contentContainer}>
      <IndependentScorekeeper />
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: { 
    flex: 1, 
    padding: 24, 
    backgroundColor: '#f7fafd',
  },
  headerContainer: {
    alignItems: 'center',
    marginBottom: 20,
    width: '100%',
    maxWidth: 800,
    alignSelf: 'center'
  },
  contentContainer: {
    width: '100%',
    maxWidth: 800,
    alignSelf: 'center',
    alignItems: 'center'
  },
  title: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#1976d2',
    marginBottom: 8,
    textAlign: 'center',
    letterSpacing: 1
  },
  divider: {
    height: 4, 
    backgroundColor: '#1976d2', 
    width: '40%', 
    marginVertical: 12,
    opacity: 0.4,
    alignSelf: 'center',
    borderRadius: 2
  },
  subtitle: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginTop: 8,
    marginBottom: 16,
    maxWidth: '80%'
  }
});

export default ScoreToolPage;
